import Axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchRoadConditionsFailure, fetchRoadConditionsSuccess, saveRoadConditionsFailure, saveRoadConditionsSuccess
} from "../actions/roadCondition.action";
import * as selectors from './selector';

//worker functions
function* workerFetchRoadConditions(action) {
  try {
    const access_token = yield select(selectors.access_token);
    const moment = require('moment');
    const resp = yield call(
      Axios.get, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_CONDITIONS_URL_PATH}`, {
      headers: {
        Authorization: 'Bearer '+access_token,
        transactionId: 'CCCRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });
    yield put(fetchRoadConditionsSuccess(resp.data));
  } catch (e) {
    yield put(fetchRoadConditionsFailure(e.message));
  }
}

function* workerSaveRoadConditions(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);

    const resp = yield call(
      Axios.put, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_CONDITIONS_URL_PATH}`, 
      { roadConditions: action.payload.roadConditions }, {
      headers: {
        Authorization: 'Bearer '+access_token,
        transactionId: 'RCE.SRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
        //accessKey: 'abf683eaa28e4e68a350413d25bd81e4'
      }
    });
    yield put(saveRoadConditionsSuccess());
  } catch (e) {
    yield put(saveRoadConditionsFailure(e.message));
  }
}
//Watcher functions
export function* watchSaveRoadConditions() {
  yield takeLatest("SAVE_ROAD_CONDITIONS_START", workerSaveRoadConditions);
}
export function* watchFetchRoadConditions() {
  yield takeLatest("FETCH_ROAD_CONDITIONS_START", workerFetchRoadConditions);
}

